import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LANGUAGES } from './core/i18n';
import { Spinner } from './shared/components/spinner/spinner';
import { Banner } from './shared/components/banner/banner';
import { Header } from './shared/components/header/header';
import { Footer } from './shared/components/footer/footer';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppMetadataService } from './core/api/app-metadata.service';
import { OrientationWarning } from './shared/components/orientation-warning/orientation-warning';
import { Toast } from './shared/components/toast/toast';
import { LoadingService } from './core/services/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Spinner, Banner, Header, Footer, OrientationWarning, Toast],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('frankische-frontend');
  protected readonly languages = LANGUAGES;

  loadingService = inject(LoadingService);

  private appMetadataService = inject(AppMetadataService);
  readonly metadata = toSignal(this.appMetadataService.getMetadata(), {
    initialValue: null,
  });
}
